import { render, staticRenderFns } from "./Wrapper.vue?vue&type=template&id=5655a0ea"
import script from "./Wrapper.vue?vue&type=script&lang=js"
export * from "./Wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5655a0ea')) {
      api.createRecord('5655a0ea', component.options)
    } else {
      api.reload('5655a0ea', component.options)
    }
    module.hot.accept("./Wrapper.vue?vue&type=template&id=5655a0ea", function () {
      api.rerender('5655a0ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operations/Wrapper.vue"
export default component.exports